<template>
    <div class="diskMain">
        <!-- 列表展示 -->
        <div v-show="isList" style="margin-top:-30px;">
            <el-table ref="table" :data="dataList" max-height="600px" 
            @selection-change="handleSelectionChange" 
            @row-click="rowClick" >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column :label="$t('diskMain.txt1')" width="50px">
                <template slot-scope="scope">
                    <span>{{scope.$index+1}}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('diskMain.txt2')">
                <template slot-scope="scope">
                    <div class="flex align-center link" @dblclick="handleOpenFolder(scope.row)">
                        <img :src="scope.row.directory ? fileTypes.folder : (fileTypes[scope.row.fileType] || fileTypes.system)" class="mr-10" width="30"/>
                        <span v-if="scope.row.directory">
                            <span v-if="!scope.row.changeName">{{scope.row.localPath}}</span>
                            <el-input v-else class="inputProjectName" v-model="scope.row.localPath" @blur="confirmProjName" :placeholder="$t('diskMain.txt3')"></el-input>
                        </span>
                        <span v-else>
                            <span>{{scope.row.localPath}}</span>
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('diskMain.txt4')"  width="100px">
                <template slot-scope="scope">
                    <span>{{(!scope.row.directory && scope.row.size)?getFileSize(scope.row.size):'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('diskMain.txt5')" width="200px">
                <template slot-scope="scope">
                    <span>{{!scope.row.directory ? formatDate(scope.row.createDate):'--'}}</span>
                </template>
            </el-table-column>
        </el-table>
<!--         <div class="table-footer tablePagination" v-show="total>0">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next"
          :total="total">
      </el-pagination>
  </div> -->
</div>
<!-- 宫格展示 -->
<div v-show="!isList">
<!--     <div class="selectAll">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('diskMain.txt6')}}</el-checkbox>
    </div> -->
    <div class="no-data" v-if="dataList.length == 0">{{$t('diskMain.txt7')}}</div>
    <div class="latticeShow">
        <ul>
            <el-checkbox-group v-model="checkedList" @change="handlecheckedListChange">
                <li ref="boxW" v-for="(item) in dataList" :key="item.path" @dblclick="handleOpenFolder(item)">
                    <div v-if="item.directory" class="fileBox">
                        <el-checkbox :key="item.path" :label="item.path"> </el-checkbox>
                        <img src="@/assets/picture/icon/format/null_folder_icon@2x.png"/>
                        <p>{{item.localPath}}</p>
                    </div>
                    <template v-else>
                        <el-checkbox :key="item.path" :label="item.path"></el-checkbox>
                        <img :src="item.directory ? fileTypes.folder : (fileTypes[item.fileType] || fileTypes.system)" class="mr-10" width="30"/>
                        <p>{{item.localPath}}</p>
                    </template>
                </li>
            </el-checkbox-group>
        </ul>
    </div>
</div>
</div>
</template>

<script>
    import { formatDate } from "@/plugins/date.js";
    import { fileTypes, getFileSize } from '@/utils/index';
    export default {
        props: {
            isList: {
                type: Boolean
            },
            multipleSelection: {
                type: Array,
                default() {
                    return []
                }
            },
            dataList: {
                type: Array,
                default() {
                    return []
                }
            },
            paths: {
                type: Array,
                default() {
                    return []
                },
            }
        },
        data() {
            const generateData = _ => {
                const data = [];
                for (let i = 1; i <= 15; i++) {
                    data.push({
                        key: i,
                        label: `备选项 ${ i }`,
                        disabled: i % 4 === 0
                    });
                }
                return data;
            };
            return {
                fileTypes,
                data: generateData(),
            activeName:'first',//tab切换
            checkAll: false,
            checkedList: [],
            cities: [],
            isIndeterminate: false,
            time:'',
            dialogFormVisible:false,//分享弹窗
            fromData:{},//分享参数
            options:[],//有效期
            //用于获取数据列表
            queryInfo: {
                mobile: '',
                page: 0,
                realName: '',
                size: 10,
                userName: '',
            },
            total: 0,
        };
    },
    methods: {
        getFileSize,
        formatDate(time) {
            var date = new Date(time);
            return formatDate(date, "yyyy-MM-dd hh:mm:ss");
        },
        rowClick(row) {
            this.$refs.table.toggleRowSelection(row);
            this.$nextTick(() =>{
                this.$emit('update:multipleSelection', this.multipleSelection);
            })
        },
        dbRowClick(row) {
            this.handleOpenFolder(row)
        },
        handleOpenFolder(item) {
            if(!item.directory) return 
                this.checkedList = [];
            this.$emit('openFloder', item)
        },
        handleSelectionChange(selectdata) {
            let arrays;
            if (selectdata.length >= 2) {
               arrays = selectdata.splice(0, selectdata.length - 1);
               arrays.forEach((row) => {
               this.$refs.table.toggleRowSelection(row);
            });
            }
            this.$emit('update:multipleSelection', selectdata);
        },
        // tab切换
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleCheckAllChange(val) {
            this.checkedList = val ? this.dataList.map(item => item.path) : [];
            this.isIndeterminate = false;
        },
        handlecheckedListChange(value) {
            console.log(value)
            this.checkedList.forEach((d) => {
              if (value[value.length - 1] === d) {
                this.checkedList = [value[value.length - 1]];
              }
            });
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.dataList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        // 见证记录模板跳转
        handleTemplate(){
            this.$router.push({path: "/sceneNav"});
        },
        // 删除
        handleDelete(){
            this.$confirm('<p class="color666 fz14">'+this.$t("diskMain.txt8")+'</p><p class="color999 fz14">'+this.$t("diskMain.txt9")+'</p>', this.$t("diskMain.txt10"), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t("diskMain.txt11"),
                cancelButtonText: this.$t("diskMain.txt12"),
                type: 'warning',
                center: true
            }).then(() => {
                this.$message({
                    type: 'info',
                    message: this.$t("diskMain.txt13")
                });
            }).catch(() => {
                this.$message({
                    type: 'success',
                    message: this.$t("diskMain.txt14")
                });
            });
        },
        // 新增文件
        handleAdd(){
            let item = {
                projName: this.$t("diskMain.txt15")
            }
            console.log(this.dataList,'this.dataList');
            if(!this.dataList){
                this.dataList.push(item);
            }else{
                this.dataList.unshift(item);
            }
        },
        validateJyh(glhm){//校验关联用户名
            var reg = new RegExp(/^[a-zA-Z]{1}\w*$/);
            if(!reg.test(glhm)){
                this.$message.error(this.$t("diskMain.txt16"));
            }
            this.mkdir(glhm);
        },
        // 新建文件夹
        async mkdir(path){
            const { data: res } = await this.$http.post("/user/info/mkdir?path="+path);
            if(!res.success){
                return this.$message.error(res.message);
            }else{
                this.$message({
                    type: 'success',
                    message: res.message
                });
                this.loadData();
            }
        },
        // 编辑
        handleEdit(row){
            this.$router.push({path: "/sceneRecordEdit",query: {id: row.id}});
        },
        // 搜索
        handleSearch(){
            this.queryInfo.pageNum = 1;
            this.queryInfo.pageSize = 10;
            this.loadData();
        },
        // 重置
        handleReset(){
            this.queryInfo = {
                keyword:'',
                manufacturerName:'',
                mobile:'',
                pageIndex: 1,
                pageSize: 10,
                pageSorts: [
                {
                    asc: true,
                    column: ''
                }
                ],
                projectName: ''
            };
            this.loadData();
        },
        // 编辑/详情
        handleDetail(row,type){
            this.$router.push({path: "/sceneRecordDetail",query: {type: type,id: row.id}});
        },
        // 页面切换
        handleCurrentChange(pageNum) {
            this.queryInfo.pageNum = pageNum;
            this.loadData();
        },
        handleSizeChange(pageSize){
            this.queryInfo.pageSize = pageSize;
            this.loadData();
        },
        // 监理现场见证记录-批量删除
        async delete(row){
            const { data: res } = await this.$http.delete("/dmp-es-admin/sms/smsWitnRec/deleteBatch?ids="+row.id);
            if(res.code !== 200){
                return this.$message.error(res.message);
            }
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.loadData();
        },
        confirmProjName() {

        },
    }
}
</script>


<style lang="less" scoped>
    .no-data{
        text-align: center;
        color: #999;
        padding-top: 5rem;
    }
    .diskMain{
        border-radius: 30px;
        overflow: hidden;
        .el-table {
            margin-top: 25px;
            padding-left: 15px;
        }
    }
    .selectAll{
        padding:0 3rem 1.7rem 3rem;
        border-bottom: 1px solid #eee;
    }
    .latticeShow{
        margin-top: 2rem;
        ul{
            .el-checkbox-group{
                display: flex;
                flex-wrap: wrap;
            }
            li{
                width: 15.5rem;
                /*height: 12rem;*/
                margin-right: 2.5rem;
                margin-bottom: 2.5rem;
                padding:1.5rem 3rem;
                cursor: pointer;
                border-radius: 10px;
                background: #fff;
                border-radius: 3rem;
                .el-checkbox{
                    display: block;
                }
                .fileBox{
                    /deep/ .el-checkbox{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }
                }
                img{
                    display: block;
                    margin:0 auto;
                    margin-top: .4rem;
                    width: auto;
                    height: 5rem;
                }
                p{
                    margin-top: 1rem;
                    font-size: 1.4rem;
                    font-weight: 400;
                    color: #222222;
                    text-align: center;
                    overflow: hidden;
                    text-overflow:ellipsis; white-space: nowrap;
                }
                &:hover{
                    background:#DAE4F9;
                }

                /deep/ .el-checkbox .el-checkbox__label{
                    display: none;
                }
            }
        }
    }
    .theme_black{
        .latticeShow p{
            color: #666
        }
    }
</style>
